module.exports = __webpack_public_path__ + "img/mono-rounded.2d918812.svg";